module.exports = __webpack_public_path__ + "img/package-delivery.0143563a.svg";